import { useEffect } from "react";
import Layout from "../components/layout/Layout.component";

import HomeDetails from "../styles/pages/HomeDetails";

import { FaArrowRight, FaWallet } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { RiCustomerService2Line } from "react-icons/ri";

import { Box, Chip, Grid2, Link, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import CardViagens from "../components/data-display/CardViagens..component";
import Skeleton from "../components/utils/Skeleton.component";
import { usePacotes } from "../services";
import { useSonho } from "../services/sonhos/use-sonhos.hooks";

function Home() {
  const { loading, data, getPacotes } = usePacotes();
  const { data: sonhosData, getSonhos } = useSonho();
  const navigate = useNavigate();

  useEffect(() => {
    getPacotes();
    getSonhos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout>
      <HomeDetails>
        <div className="hero-section">
          <div className="content-hero">
            <h1>
              Bem vindo a <span>Bellatchau!</span>
            </h1>
            <p>Descubra o Mundo com Estilo.</p>
            <p>Bellatchau, Suas Viagens Inesquecíveis!</p>
          </div>
        </div>
        <div className="apresentation">
          <div className="content-apresentation">
            <div className="apresentation-clomun">
              <div className="icon">
                <FaLocationDot />
              </div>
              <div className="title-column">Destino escolhido a dedo</div>
              <p className="desc">
                Nosso rigoroso processo de triagem significa que você verá
                apenas as caminhadas da melhor qualidade.
              </p>
            </div>
            <div className="apresentation-clomun">
              <div className="icon">
                <FaWallet />
              </div>
              <div className="title-column">Melhor preço garantido</div>
              <p className="desc">
                Nossa Garantia de Melhor Preço significa que você pode ter
                certeza de reservar com o melhor preço.
              </p>
            </div>
            <div className="apresentation-clomun">
              <div className="icon">
                <RiCustomerService2Line />
              </div>
              <div className="title-column">Atendimento 24 horas</div>
              <p className="desc">
                Nossos atendentes estão à disposição 24 horas por dia, 7 dias
                por semana, para tornar sua experiência incrível.
              </p>
            </div>
          </div>
        </div>
        <div className="section">
          <div className="title-section">
            <div className="slug">Viagens</div>
            <div className="line"></div>
            <p>Explore as melhores viagens da Bellatchau</p>
          </div>
          <div className="list-section">
            {loading ? (
              <>
                <div className="item-list">
                  <Skeleton height="500px" style={{ borderRadius: "16px" }} />
                </div>
                <div className="item-list">
                  <Skeleton height="500px" style={{ borderRadius: "16px" }} />
                </div>
                <div className="item-list">
                  <Skeleton height="500px" style={{ borderRadius: "16px" }} />
                </div>
                <div className="item-list">
                  <Skeleton height="500px" style={{ borderRadius: "16px" }} />
                </div>
              </>
            ) : (
              <>
                {data?.length === 0 ? (
                  <p>Nenhuma viagem cadastrada</p>
                ) : (
                  <>
                    {data?.slice(0, 4).map((item, key) => {
                      return (
                        <div className="item-list" key={`${item.title}-${key}`}>
                          <CardViagens data={item} />
                        </div>
                      );
                    })}
                  </>
                )}
              </>
            )}
          </div>
          <Grid2 display="flex" justifyContent="flex-end" mt={4}>
            <Link
              href="/viagens"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                color: "black",
              }}
              underline="hover"
            >
              <Typography variant="h6">Mais viagens</Typography>
              <FaArrowRight />
            </Link>
          </Grid2>
        </div>
        <div
          className="section-full-width"
          style={{
            background: "#F9F9F9",
            width: "100%",
          }}
        >
          <div className="content-section-full-width">
            <div className="title-section">
              <div className="slug">Sonhos Realizados</div>
              <div className="line"></div>
              <p>Conheca sonhos já realizados pela Bellatchau!</p>
            </div>
            <Box
              mt={6}
              sx={{
                maxWidth: "1200px",
              }}
            >
              <Swiper
                centeredSlides={true}
                pagination={{
                  clickable: true,
                }}
                autoplay={{
                  delay: 3500,
                  disableOnInteraction: false,
                }}
                modules={[Pagination, Autoplay]}
              >
                {sonhosData.slice(0, 5).map((item) => (
                  <SwiperSlide key={item.id}>
                    <Box
                      sx={{
                        position: "relative",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        navigate(
                          `/sonhos-realizados/${item.title
                            .replace(/ /g, "-")
                            .toLocaleLowerCase()}?id=${item.id}`
                        )
                      }
                    >
                      <Typography
                        pl={2}
                        variant="h4"
                        className="swiper-title"
                        sx={{
                          textShadow: "1px 1px 1px #000",
                        }}
                      >
                        {item.title}
                      </Typography>
                      <Chip
                        className="swiper-chip"
                        color="primary"
                        label={item.local}
                        icon={<FaLocationDot />}
                      />
                      <img
                        src={item.imagesUrl[0]}
                        alt={item.title}
                        style={{
                          width: "100%",
                          height: "400px",
                          objectFit: "cover",
                          borderRadius: "16px",
                        }}
                      />
                    </Box>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Box>
            <Grid2 display="flex" justifyContent="flex-end" mt={4}>
              <Link
                href="/sonhos-realizados"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  color: "black",
                }}
                underline="hover"
              >
                <Typography variant="h6">Ver sonhos</Typography>
                <FaArrowRight />
              </Link>
            </Grid2>
          </div>
        </div>
      </HomeDetails>
    </Layout>
  );
}

export default Home;
